import React from "react";
import { useState, useEffect } from "react";

import WarningCard from "./WarningCard";

import "react-inner-image-zoom/lib/InnerImageZoom/styles.css";
import ReactModal from "react-modal";

import "./RoomInfoStyle.css";

import PlaceholderPreview from "./../../../../assets/images/Default_RoomDetail.jpg";
import { FaHashtag } from "react-icons/fa";
import { FaMapMarkedAlt } from "react-icons/fa";
import { FaBuilding } from "react-icons/fa";
import { FaMapMarkerAlt } from "react-icons/fa";
import { FaExpand } from "react-icons/fa";
import { FaTimes } from "react-icons/fa";

ReactModal.setAppElement("#root");

const RoomInfo = ({ selectedRoom, troubleReportData }) => {
  const [displayWarning, setDisplayWarning] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const handleWarningClose = () => setDisplayWarning(!displayWarning);

  /* React hook that will be executed on creation and every time the dependencies update. */
  useEffect(() => {
    setDisplayWarning(troubleReportData.length > 0);
  }, [selectedRoom, troubleReportData]);

  /**
   * Method to open campus plan in full screen as modal
   */
  const handleOpenModal = () => {
    setShowModal(true);
  };

  /**
   * Method to close campus plan modal
   */
  const handleCloseModal = () => {
    setShowModal(false);
  };

  return (
    <div className="room-info-container">
      {/* Handle notification display */}
      {displayWarning && <WarningCard handleClose={handleWarningClose} />}
      <div className="room-preview-container" style={{ position: "relative" }}>
        {/* Add data sensitive calssname and fallback image */}
        <img
          className={
            selectedRoom.startfoto !== undefined &&
            selectedRoom.startfoto !== ""
              ? "room-prev"
              : "room-prev default-prev"
          }
          src={
            selectedRoom.startfoto !== undefined &&
            selectedRoom.startfoto !== ""
              ? `https://famos.app.uni-regensburg.de/famosdaten/hoersaele/campus_detailplan_png/${selectedRoom.startfoto}`
              : PlaceholderPreview
          }
          alt=""
          onClick={handleOpenModal}
        />
        <button className="zoom-button" onClick={handleOpenModal}>
          <FaExpand style={{ width: "16px", height: "16px" }} />
        </button>
      </div>

      <div className="room-info-details">
        <div className="room-info-detail-item">
          <FaHashtag />
          <p>{selectedRoom.raumcode}</p>
        </div>

        <div className="room-info-detail-item">
          <FaBuilding />
          <p>{selectedRoom.hoersaal}</p>
        </div>

        <div className="room-info-detail-item">
          <FaMapMarkedAlt />
          <p>{selectedRoom.bauwerk}</p>
        </div>

        <div className="room-info-detail-item">
          <FaMapMarkerAlt />
          <p>{selectedRoom.benennung}</p>
        </div>
      </div>

      {/* Fullscreen campus plan modal */}
      <ReactModal
        isOpen={showModal}
        contentLabel={`Campusplan für Raum ${selectedRoom.hoersaal}`}
        ariaHideApp={true}
        onRequestClose={handleCloseModal}
        shouldFocusAfterRender={true}
        shouldCloseOnOverlayClick={true}
        shouldCloseOnEsc={true}
        shouldReturnFocusAfterClose={true}
        style={{
          overlay: {
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            width: "100%",
            height: "auto",
            zIndex: 1000,
            backgroundColor: "var(--color-background-primary-opaque)",
          },
          content: {
            position: "absolute",
            top: "32px",
            left: "32px",
            right: "32px",
            bottom: "32px",
            border: "none",
            background: "var(--color-neutral-white)",
            boxShadow: "var(--ui-shadow-regular)",
            overflow: "auto",
            WebkitOverflowScrolling: "touch",
            borderRadius: "8px",
            outline: "none",
            padding: 0,
          },
        }}
      >
        <button className="zoom-button" onClick={handleCloseModal}>
          <FaTimes style={{ width: "16px", height: "16px" }} />
        </button>
        <img
          src={
            selectedRoom.startfoto !== undefined &&
            selectedRoom.startfoto !== ""
              ? `https://famos.app.uni-regensburg.de/famosdaten/hoersaele/campus_detailplan_png/${selectedRoom.startfoto}`
              : PlaceholderPreview
          }
          alt={`Campusplan für Raum ${selectedRoom.hoersaal}`}
          className={"campus-preview-modal"}
        />
      </ReactModal>
    </div>
  );
};

export default RoomInfo;
